import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import intl from '$intl';
import { screen } from '../../../components/hoc';
import FactoryHeader from '$fcomponents/header';
import { TableView2, Header as FixedHeader } from '$gcomponents/widgets';

import FILE_TABLE, { FILE_TABLE_CONFIG } from './table';
import PasscodeDialog from './passcodeDialog';
import { IonPageWrapper } from './styles';
import { fileActions } from '$fbusiness/redux/file';
import { DOC_TYPE_LIST } from '$fbusiness/enums/options/docType';
import StoreModel from '$fbusiness/models/store';
import FileModel from '$fbusiness/models/file';
import { configs } from '$configs';

interface MyFilesScreenProps {
  store: StoreModel;
}

const Header =
  configs.display.layout === 'FIXED_HEADER' ? (
    <FactoryHeader title="SCREEN.FILES.TITLE" />
  ) : (
    <FixedHeader title="SCREEN.FILES.TITLE" />
  );

const MyFilesScreen: React.FC<MyFilesScreenProps> = ({ store }) => {
  const [filter, setFilter] = useState<any>({ query: '', forceRefresh: true, storeId: store?.id });
  const [passcodeFile, setPasscodeFile] = useState<FileModel | null>(null);

  const onChangeType = (docType) => {
    setFilter({ ...filter, docType, forceRefresh: !filter.forceRefresh });
  };

  return (
    <IonPageWrapper>
      {Header}
      <div className="type-filter">
        <FormControl size="small" variant="outlined">
          <InputLabel id="type-select">{intl('SCREEN.FILES.COLS.TYPE')}</InputLabel>
          <Select
            size="small"
            id="type-select"
            variant="outlined"
            label={intl('SCREEN.FILES.COLS.TYPE')}
            value={filter.docType || ''}
            onChange={(e) => onChangeType(e.target.value)}>
            <MenuItem value="">{intl('SCREEN.FILES.ALL_TYPES')}</MenuItem>
            {DOC_TYPE_LIST.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <TableView2
        tableConfig={FILE_TABLE_CONFIG}
        TABLE={FILE_TABLE((file) => setPasscodeFile(file))}
        filter={filter}
      />
      <PasscodeDialog file={passcodeFile} show={!!passcodeFile} onClose={() => setPasscodeFile(null)} />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  store: state.factory.store,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  fetchFile: fileActions.fetchFile,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(MyFilesScreen));
